import React from 'react';
import CourseDetail from '../components/course/pages/CourseDetail';

function CourseDetailPage() {
  return (
    <div className="course-detail-page-wrapper">
      <CourseDetail />
    </div>
  );
}

export default CourseDetailPage;
